// Action creator

export const setUser = (user) => {
    return {
      type: 'SET_USER',
      user,
    };
  };